import React from 'react'

const Complete = () => {
  return (
    <div className=' text-4xl flex'>Completed experiment</div>
  )
}

export default Complete